import React from 'react'
import styled from 'styled-components'
import Header from '../common/header'
import Footer from '../common/footer'
import Main from './main'

const Wrapper = styled.div`
    .person {
        padding-top: 30px;
        padding-bottom: 30px;

        .img-wrapper {
            margin-bottom: 30px;
            text-align: center;
        }

        img {
            width: 200px;
            border-radius: 5000px;
        }

        h5 {
            font-size: 17px;
            margin-bottom: 30px;
            color: grey;
        }
    }
`

export default () => (
    <Wrapper>
        <Header />
        <Main />
        <Footer />
    </Wrapper>
)
